class Utilities {
  getGdc(gdc) {
    switch (gdc) {
      case "CORPORATE":
        return 1;
      case "CHEMICALS":
        return 2;
      case "PACKAGING":
        return 3;
      case "CBM":
        return 4;
      default:
        return 1;
    }
  }

  numberWithCommas(x) {
    if (x === "" || x === 0 || x === "0") return "-";
    if (x === null || x === undefined) return "-";
    x = parseFloat(Math.round(x * 100) / 100)
      .toFixed(2)
      .toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
    return `${x}`;
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, "g"), replace);
  }

  validateBookName(bookName) {
    if (bookName.includes(" ver."))
      return bookName.substring(0, bookName.indexOf(" ver."));
    return bookName;
  }

  countDot(text) {
    var count = text.split(".").length;
    return count - 1;
  }

  onInitial(topic, conditionList) {
    const topicModel = {
      topicId: undefined,
      bookSubjectId: undefined,
      topicNo: "",
      topicTitle: "",
      approve: undefined,
      sign: undefined,
      report: undefined,
      hasCondition: false,
      type: "S",
      approveText: null,
      signText: null,
      reportText: null,
      remark: null,
      comment: null,
      conditionType: "A",
      detail: [],
    };

    if (topic) {
      topicModel.topicId = topic.TopicID;
      topicModel.bookSubjectId = topic.BookSubjectID;
      topicModel.topicNo = topic.TopicNo;
      topicModel.topicTitle = topic.TopicTitle;
      topicModel.approve = topic.Approval;
      topicModel.sign = topic.Sign;
      topicModel.report = topic.Report;
      topicModel.hasCondition = topic.HasCondition;
      topicModel.type = topic.Type;
      topicModel.approveText = topic.ApprovalText;
      topicModel.signText = topic.SignText;
      topicModel.reportText = topic.ReportText;
      topicModel.remark = topic.Remark;
      topicModel.comment = topic.Comments;
      if (conditionList.length > 0)
        topicModel.conditionType = conditionList[0].Type;

      conditionList.forEach((condition, i) => {
        if (
          topic.SubjectTitle === condition.SubjectTitle &&
          topic.TopicNo === condition.TopicNo
        ) {
          topicModel.detail.push({
            conditionId: condition.ConditionID,
            conditionDetailId: condition.ConditionDetailID,
            conditionTitle: condition.ConditionTitle,
            squence: condition.Sequence,
            operation: condition.Operation,
            value: condition.Value,
            approve: condition.Approval,
            sign: condition.Sign,
            report: condition.Report,
            approveText: condition.ApprovalText,
            signText: condition.SignText,
            reportText: condition.ReportText,
            remark: condition.Remark,
            comment: condition.Comments,
          });
        }
      });
      return topicModel;
    }
    return topicModel;
  }
}

export default new Utilities();
